/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/conversion': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M20.811 11.194l-.565.565A5.964 5.964 0 0122 16c0 2.795-1.925 5.145-4.518 5.807A1.593 1.593 0 0016 20.8a1.6 1.6 0 100 3.201c.813 0 1.477-.607 1.579-1.393C20.568 21.893 22.8 19.205 22.8 16a6.755 6.755 0 00-1.989-4.806zM14.517 10.193A1.6 1.6 0 1016 8c-.813 0-1.477.608-1.579 1.392C11.432 10.108 9.2 12.795 9.2 16c0 1.814.707 3.523 1.991 4.809l.565-.565A5.972 5.972 0 0110 16c0-2.795 1.925-5.144 4.517-5.807z"/><path pid="1" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/>'
  }
})
